import React, { Component } from 'react'
import { Form } from 'antd';
import { InputNumber } from '../../../../../components/common/input-number';


export class Punishment extends Component {

    render() {
        const { unlimitEdit, isOwner, typeOption } = this.props;
        return <>
            <div className="title-contract title-special">11. Tỷ lệ % phạt khách hàng khi chấm dứt sớm HĐ*</div>
            <Form.Item
                wrapperCol={24}
                className="punishment"
                name={'penalty_rate_early_termination'}
                rules={[
                    {
                        required: true,
                        message: `Vui lòng nhập định tỷ lệ phạt!`,
                    },
                    {
                        pattern: /^100$|^[0-9]{1,2}$|^[0-9]{1,2}\.[0-9]{1,100}$/,
                        message: `Vui lòng nhập giá trị trong trong khoảng 0-100!`,
                    },
                ]}>
                <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} percent disabled={!unlimitEdit || (typeOption !== 'create_new' && !isOwner)} max={100} suffix={"%"} />
            </Form.Item>
        </>
    }
}
